import { langTextMap } from '../common/i18n';
import { getSchemeLink, PLATFORM_TYPE } from '../common/scheme';
import { computed } from 'vue-demi';
const { useUser, useI18n, useBehaviour, useToast } = require('@fegobull/webapi').use;
const { runBehaviour } = useBehaviour();
const Toast = useToast();

export default (props, { setSelectStatus, addAll }) => {
    const $t = useI18n(langTextMap, props.language);

    // 表头配置
    const headerConfig = computed(() => {
        return {
            show: props.showHeader,
            column: {
                name: $t('name'),
                trend: $t('trend'),
                increase: $t(props.increaseType),
                wch: $t('wch')
            }
        };
    });

    // 列展示配置
    const columnConfig = computed(() => {
        return {
            showRankTag: props.showRankTag,
            showTrend: props.showTrend,
            showIncrease: props.showIncrease,
            showAddWch: props.showAddWch,
            showAddWchCount: props.showAddWchCount,
        };
    });

    const addAllConfig = computed(() => {
        return {
            show: props.showAddAll,
            text: $t('add_all_wch')
        };
    });

    const tagMap = computed(() => {
        const tagString = props.tagString;
        const map = {};
        if (!tagString) {
            return map;
        }
        const tagArr = tagString.split('/');
        tagArr.forEach((item) => {
            const [key, value] = item.split('-');
            if (key) {
                // 转为大写
                map[key.toUpperCase()] = value;
            }
        });
        return map;
    });

    // 点击跳转
    const itemClick = ($event, stock) => {
        if (props.schemeType) {
            const link = getSchemeLink(props.schemeType, stock, props.platform || PLATFORM_TYPE.MOOMOO);

            link &&
                runBehaviour(
                    null,
                    {
                        type: props.platform === PLATFORM_TYPE.NIUNIU ? 'jump' : 'jumpMM',
                        value: link
                    },
                    $event
                );
        }
    };

    // icon点击跳转
    const iconClick = async ($event, stock, selected) => {
        const { isLogin } = useUser();
        if (!isLogin) {
            return runBehaviour(null, { type: 'login', withQuery: true }, $event);
        }
        await setSelectStatus(stock, selected);
        Toast.msg($t(selected ? 'del_selected_succ' : 'add_selected_succ'));
    };

    // 添加全部自选股
    const addAllClick = async ($event) => {
        const { isLogin } = useUser();
        if (!isLogin) {
            return runBehaviour(null, { type: 'login', withQuery: true }, $event);
        }
        await addAll();
        Toast.msg($t('add_selected_succ'));
    };

    return {
        headerConfig,
        columnConfig,
        addAllConfig,
        tagMap,
        itemClick,
        iconClick,
        addAllClick,
    };
};
